import { updatePassword as firebaseUpdatePassword, updateProfile } from "firebase/auth";
import { collection, doc, getDoc, getFirestore, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { InvoiceHistory, UserData } from "types";

import { functions } from "../../resource/functions";
import { auth, firebaseApp } from "./initFirebase";

const db = getFirestore(firebaseApp);

export const updateUserProfile = (newProfileInfo: { displayName?: string; photoUrl?: string }) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("Not logged");
  }

  return updateProfile(user, newProfileInfo);
};

export const updatePassword = async (newPassword: string) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("Not logged");
  }

  try {
    return await firebaseUpdatePassword(user, newPassword);
  } catch (error) {
    if ((error as Error & { code: string }).code === "auth/requires-recent-login") {
      throw new Error(
        "Esta operação é sensível e requer autenticação recente. Por favor faça login novamente e tente de novo."
      );
    }

    throw error;
  }
};

export const updateUserAddress = async ({
  userUid,
  useAsAdmin,
  address,
}: {
  useAsAdmin?: boolean;
  userUid?: string;
  address: {
    postalCode: string;
    street: string;
    complement: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
  };
}) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("Not logged");
  }

  if (!useAsAdmin) {
    return updateUserDoc({ userUid: user.uid, data: { address } });
  }

  const userAdditionalData = (await getDoc(doc(collection(db, "users"), userUid))).data();

  if (userAdditionalData?.type !== "admin") {
    throw new Error("User is not admin");
  }

  return updateUserDoc({ userUid: userUid!, data: { address } });
};

export const updateUserDoc = async ({ userUid, data }: { userUid: string; data: Partial<UserData> }) => {
  return updateDoc(doc(collection(db, "users"), userUid), data);
};

export const cancelSubscription = httpsCallable<any, any, any>(functions, "cancelSubscription");

export const invoiceHistory = httpsCallable<undefined, InvoiceHistory>(functions, "invoiceHistory");

export const reviseSubscription = httpsCallable(functions, "reviseSubscription");

export const checkSubscription = httpsCallable(functions, "checkSubscription");
